var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        right: "",
        "nudge-bottom": 20,
        "nudge-right": 20,
        "close-on-content-click": true,
        "content-class": "conexao-actions-menu"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var onTooltip = ref.on
                          var attrsTooltip = ref.attrs
                          return [
                            _c(
                              "span",
                              _vm._g(
                                _vm._b({}, "span", attrsTooltip, false),
                                onTooltip
                              ),
                              [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          "data-test":
                                            "conexao-actions-trigger",
                                          icon: "",
                                          primary: "",
                                          disabled: _vm.disabled,
                                          loading: _vm.loading
                                        }
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("icon-svg", {
                                      attrs: {
                                        name: _vm.icons.dotsVertical,
                                        size: "16",
                                        color: "primary"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_c("span", [_vm._v("Ações")])]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menuOpen,
        callback: function($$v) {
          _vm.menuOpen = $$v
        },
        expression: "menuOpen"
      }
    },
    [
      _c(
        "v-list",
        { staticClass: "az-list-no-icon-spacing py-1", attrs: { dense: "" } },
        [
          _vm.isGestor || _vm.hasIndividual
            ? _c(
                "v-list-item",
                {
                  attrs: {
                    disabled: !_vm.canRefreshChats,
                    "data-test": "menu-refresh-chats-list"
                  },
                  on: { click: _vm.onRefreshChats }
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _vm.refreshing
                        ? _c("v-progress-circular", {
                            attrs: {
                              size: 16,
                              width: 2,
                              indeterminate: "",
                              color: "#8e8e8e"
                            }
                          })
                        : _c("icon-svg", {
                            attrs: {
                              name: _vm.icons.refresh,
                              size: "16",
                              color: "#8e8e8e"
                            }
                          })
                    ],
                    1
                  ),
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.refreshChatsLabel))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.isGestor || _vm.hasIndividual ? _c("v-divider") : _vm._e(),
          _vm.canGoToConfig
            ? _c(
                "v-list-item",
                {
                  attrs: { "data-test": "menu-goto-config" },
                  on: { click: _vm.goToConfig }
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: _vm.icons.settings,
                          size: "16",
                          color: "#8e8e8e"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-list-item-title", [_vm._v(" Ir para Configurações ")])
                ],
                1
              )
            : _vm._e(),
          !_vm.isGestor
            ? [
                _vm._l(_vm.conexoesIndividuaisView, function(c, i) {
                  return [
                    i > 0 || _vm.canGoToConfig
                      ? _c("v-divider", { key: "sep-" + c.id })
                      : _vm._e(),
                    _c(
                      "v-list-item",
                      {
                        key: "status-" + c.id,
                        staticClass: "status-row",
                        attrs: { disabled: "" }
                      },
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "d-flex align-center" },
                          [
                            c.nomeExibido
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "az-text-small font-weight-bold text-break mr-2",
                                    attrs: { "data-test": "menu-conexao-nome" }
                                  },
                                  [_vm._v(" " + _vm._s(c.nomeExibido) + " ")]
                                )
                              : _vm._e(),
                            _c("BaseStatus", {
                              attrs: {
                                text: "",
                                content: c.statusLabel,
                                color: c.statusColor
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-divider", { key: "div-" + c.id }),
                    !c.conectado
                      ? _c(
                          "v-list-item",
                          {
                            key: "qrcode-" + c.id,
                            attrs: { "data-test": "menu-qrcode" },
                            on: {
                              click: function($event) {
                                return _vm.openQrCode(c)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.icons.qrcode,
                                    size: "16",
                                    color: "#8e8e8e"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-list-item-title", [
                              _vm._v("Conectar via QR Code")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    c.conectado
                      ? _c(
                          "v-list-item",
                          {
                            key: "reiniciar-" + c.id,
                            attrs: { "data-test": "menu-reiniciar" },
                            on: {
                              click: function($event) {
                                return _vm.onReiniciar(c)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.icons.refresh,
                                    size: "16",
                                    color: "#8e8e8e"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-list-item-title", [
                              _vm._v("Reiniciar conexão")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    c.conectado
                      ? _c(
                          "v-list-item",
                          {
                            key: "desconectar-" + c.id,
                            attrs: { "data-test": "menu-desconectar" },
                            on: {
                              click: function($event) {
                                return _vm.onDesconectar(c)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: _vm.icons.disconnect,
                                    size: "16",
                                    color: "#8e8e8e"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-list-item-title", [_vm._v("Desconectar")])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-list-item",
                      {
                        key: "desativar-" + c.id,
                        attrs: { "data-test": "menu-desativar" },
                        on: {
                          click: function($event) {
                            return _vm.onDesativar(c)
                          }
                        }
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.icons.deactivate,
                                size: "16",
                                color: "#8e8e8e"
                              }
                            })
                          ],
                          1
                        ),
                        _c("v-list-item-title", [_vm._v("Desativar conexão")])
                      ],
                      1
                    ),
                    _c("v-divider", { key: "div-remover-" + c.id }),
                    _c(
                      "v-list-item",
                      {
                        key: "remover-" + c.id,
                        attrs: { "data-test": "menu-remover" },
                        on: {
                          click: function($event) {
                            return _vm.onRemoverPermanentemente(c)
                          }
                        }
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.icons.delete,
                                size: "16",
                                color: "#8e8e8e"
                              }
                            })
                          ],
                          1
                        ),
                        _c("v-list-item-title", [
                          _vm._v("Remover permanentemente")
                        ])
                      ],
                      1
                    )
                  ]
                })
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }